// extracted by extract-css-chunks-webpack-plugin
module.exports = {"footerLinkList":"_3IL1St","listWrapper":"_3yqysb","listHeader":"_3mu0cT","linksWrapper":"_2lt5d1","linkItem":"_3DpVGg","link":"_1I4VqY"};